var render = function render(){var _vm=this,_c=_vm._self._c;return _c('i',{staticClass:"fal",class:_vm.$IconName(_vm.from),attrs:{"width":_vm.width}})
}
var staticRenderFns = []

export { render, staticRenderFns }